<script setup lang="ts">
import type { NuxtError } from '#app'

const { setDefaultHead } = usePageHeadMetaData()

setDefaultHead()

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true,
  },
})
</script>

<template>
  <div>
    <TheHeader />

    <template v-if="error.statusCode === 404">
      <ErrorNotFound />
    </template>
    <template v-else>
      <ErrorGeneral />
    </template>

    <TheFooter />
    <TheDialogAlert />
    <TheDialogConfirm />
    <TheSnackbar />
  </div>
</template>
